export const TAB_NAMES = {
  CalculatorComponent: 'CalculatorComponent',
};
